<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">취약점 정보</h1>
      <h2 class="page-tit">보안 공지</h2>
    </div>
    <article class="board-view">
      <header class="detail-view__head">
        <p class="detail-view__tit">{{ item.title }}</p>
        <div class="detail-view__info__wrap" aria-label="게시물 정보">
          <p class="detail-view__info">
            작성일 :{{ convertDateFormatFromId(item.id) }}
          </p>
          <p class="detail-view__info">조회수 : {{ item.view_cnt }}</p>
        </div>
      </header>
      <div
        class="detail-view__body pd0"
        v-dompurify-html="item.content_html"
      ></div>
      <div class="detail-view__nav">
        <a
          v-if="prevItem"
          @click.prevent="goToItem(prevItem.id)"
          class="detail-view__nav__link detail-view__nav__link--prev"
          aria-label="이전글"
        >
          <p class="detail-view__nav-label" aria-hidden="true">
            <i class="svg_icon icon_arrow_down"></i> 이전글
          </p>
          <p class="detail-view__nav-ti">{{ prevItem.title }}</p>
        </a>
        <a
          v-if="nextItem"
          class="detail-view__nav__link"
          aria-label="다음글"
          @click.prevent="goToItem(nextItem.id)"
        >
          <p class="detail-view__nav-label" aria-hidden="true">
            <i class="svg_icon icon_arrow_down"></i> 다음글
          </p>
          <p class="detail-view__nav-tit">{{ nextItem.title }}</p>
        </a>
      </div>
    </article>

    <div class="btn__wrap type-bottom-board">
      <router-link to="/info/vuln/notice" class="btn btn--m btn--blue"
        >목록</router-link
      >
    </div>
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { inject, onMounted, ref } from "vue";
import { useStore } from "vuex";
import dt from "@/component/DateTime.js";
import dc from "@/component/DataChk.js";

export default {
  setup() {
    const axios = inject("axios");
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const item = ref({ title: "", id: "", content_html: "", view_cnt: "" });
    const prevItem = ref(item.value); // 이전글 데이터
    const nextItem = ref(item.value); // 다음글 데이터
    const searchInfo = ref({ collectionType: "VULNOTICE" });
    const id = route.query.id ? route.query.id : null;
    // methods 정의
    const fetchNoticeDetail = async (id) => {
      searchInfo.value.id = id;
      showLoading();
      axios
        .post("/core/pu/view/vuln-notice/detail/get", searchInfo.value)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const indices =
              res.data.resList.length === 3 ? [0, 1, 2] : [1, 0, null];
            let [pre, current, next] = indices;
            item.value = res.data.resList[current];
            prevItem.value = res.data.resList[pre];
            nextItem.value = next ? res.data.resList[next] : null;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const convertDateFormatFromId = (objectId) => {
      return dt.dateFromObjectId(objectId);
    };

    const goToItem = async (id) => {
      // 1. 새로운 ID로 게시물 상세 정보 다시 불러오기
      await fetchNoticeDetail(id);

      // 2. 브라우저 히스토리를 추가하지 않고 URL만 변경
      router.replace({ query: { id } });
    };
    // life cycle 정의
    onMounted(() => {
      const data = sessionStorage.getItem("vulnNoticeSearchInfo");
      if (data) {
        searchInfo.value = JSON.parse(data);
      }
      if (!id) {
        router.push("/");
        return;
      }
      fetchNoticeDetail(id);
    });
    // html에서 사용될 데이터 정의
    return {
      item,
      prevItem,
      nextItem,
      convertDateFormatFromId,
      goToItem,
    };
  },
};
</script>
<style scoped>
</style>